import PropTypes from 'prop-types';

import { trackEvent, trackLegacyEvent } from 'helpers/analytics';
import css from 'styles/components/hf/zappos/footerSocial.scss';
import marketplace from 'cfg/marketplace.json';

const { links: { social: {
  instagramLink,
  facebookLink,
  twitterLink,
  pinterestLink,
  youtubeLink
} } } = marketplace;

const FooterSocial = (props, { testId = () => null }) => (
  <div className={css.social}>
    <h3>Connect With Us</h3>
    <div>
      <a
        href={facebookLink}
        onClick={() => {
          trackEvent('TE_FOOTER_SOCIAL', 'facebook');
          trackLegacyEvent('Footer', 'Connect-with-us', 'Facebook');
        }}
        data-test-id={testId('footerFacebook')}
        className={css.fbIcon}
        target="_blank"
        rel="noopener noreferrer">
          Facebook
      </a>
      <a
        href={instagramLink}
        onClick={() => {
          trackEvent('TE_FOOTER_SOCIAL', 'instagram');
          trackLegacyEvent('Footer', 'Connect-with-us', 'Instagram');
        }}
        data-test-id={testId('footerInstagram')}
        className={css.instaIcon}
        target="_blank"
        rel="noopener noreferrer">
          Instagram
      </a>
      <a
        href={twitterLink}
        onClick={() => {
          trackEvent('TE_FOOTER_SOCIAL', 'twitter');
          trackLegacyEvent('Footer', 'Connect-with-us', 'Twitter');
        }}
        data-test-id={testId('footerTwitter')}
        className={css.twitIcon}
        target="_blank"
        rel="noopener noreferrer">
          Twitter
      </a>
      <a
        href={pinterestLink}
        onClick={() => {
          trackEvent('TE_FOOTER_SOCIAL', 'pinterest');
          trackLegacyEvent('Footer', 'Connect-with-us', 'Pinterest');
        }}
        data-test-id={testId('footerPinterest')}
        className={css.pinIcon}
        target="_blank"
        rel="noopener noreferrer">
          Pinterest
      </a>
      <a
        href={youtubeLink}
        onClick={() => trackEvent('TE_FOOTER_SOCIAL', 'youtube')}
        data-test-id={testId('footerYoutube')}
        className={css.ytIcon}
        target="_blank"
        rel="noopener noreferrer">
          Youtube
      </a>
    </div>
  </div>
);

FooterSocial.contextTypes = {
  testId: PropTypes.func
};

export default FooterSocial;
